import { createReducer, on } from '@ngrx/store';
import * as SessionActions from '../actions/session.actions';
import { SessionState } from '../states/app.state';

export const initialState: SessionState = {
  draftBoards: [],
  selectedBoard: undefined,
  tags: []
};

export const sessionReducer = createReducer(
  initialState,
  on(SessionActions.setDraftBoards, (state, { draftBoards }) => ({ ...state, draftBoards: draftBoards })),
  on(SessionActions.setSelectedBoard, (state, { selectedBoard }) => ({ ...state, selectedBoard })),
  on(SessionActions.setTags, (state, { tags }) => ({ ...state, tags }))

);
